
$(document).on("change","variant-selects select.js-product-characteristics-select.js-options",function (){
    // console.log(getCurentVariant());
    updateURL(getCurentVariant().id)
    updateContent(getCurentVariant().id)
    updateMedia(getCurentVariant());
});
$(document).on("change","variant-selects select.js-product-characteristics-select.js-first-option",function (){
    // updateURL()
    updateContent(getCurentVariantForFirstOption().id)
    updateURL(getCurentVariantForFirstOption().id)
    getCurentVariantForFirstOption()
    updateMedia(getCurentVariantForFirstOption());
});


function getCurentVariant() {
    let variantData = JSON.parse($('variant-selects').find($('[type="application/json"]'))[0].textContent);
    let options =  Array.from($(`variant-selects select.js-product-characteristics-select`), select => select.value)
    let curentVariant = variantData.find((variant) => {
        return !variant.options.map((option, index) => {
            return options[index] === option;
        }).includes(false);
    })

    return curentVariant;
}
function getCurentVariantForFirstOption() {
    let variantData = JSON.parse($('variant-selects').find($('[type="application/json"]'))[0].textContent);
    let options =  $(`variant-selects select.js-product-characteristics-select.js-first-option`).val()
    let curentVariant = variantData.find(variant => variant.option1 == options)
    return curentVariant;
}
function updateURL(id) {
    if (!getCurentVariant()) return;
    window.history.replaceState({ }, '', `${$('variant-selects').attr('data-url')}?variant=${id}`);
}
function updateMedia(variant) {
    if (!variant || !variant.featured_image) return;
    let variant_image= variant.featured_image.id;
    let slider_image = $('.js-product-image').find($(`[data-media-id="${variant_image}"]:not(.slick-cloned)`)).attr('data-slick-index');
    $('.js-product-img-preview-slider').slick('slickGoTo', slider_image);
}

function updateContent(id) {
    console.log("idddddddddd", id);
    $('.main-product__body').find($('input[name="id"]')).val(id);
    $('.main-product__body').find($('input[name="quantity"]')).val(1);
    $(document).find($('.main-product__characteristics')).addClass('loading');
    fetch(`${$('variant-selects').attr('data-url')}?variant=${id}`)
        .then(function (response) {
            return response.text();
        }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // console.log(doc);

        if( doc.querySelector('.js-body-product').querySelector('.main-product__characteristics') != null){
            var variant = doc.querySelector('.js-body-product').querySelector('.main-product__characteristics').innerHTML
        }
        if( doc.querySelector('.js-product-info-block').querySelector('.main-product__info-status') != null){
            var status = doc.querySelector('.js-product-info-block').querySelector('.main-product__info-status').outerHTML
            var status_Class = doc.querySelector('.js-product-info-block').querySelector('.main-product__info-status').classList
            if (status_Class.contains('stoke')) {
                var status_tag = 'stoke';
            } else if(status_Class.contains('made-to-order')) {
                var status_tag = 'made-to-order';
            }
        }
        if( doc.querySelector('.js-body-product').querySelector('.js-proudct-price') != null){
            var price = doc.querySelector('.js-body-product').querySelector('.js-proudct-price').innerHTML
        }
        if( doc.querySelector('.js-body-product').querySelector('.main-product__status-wrapper') != null){
            var Status_info = doc.querySelector('.js-body-product').querySelector('.main-product__status-wrapper').outerHTML
        }
        if( doc.querySelector('.js-body-product').querySelector('.main-product__overview') != null){
            var product_overview = doc.querySelector('.js-body-product').querySelector('.main-product__overview').innerHTML
        }
        if( doc.querySelector('.product-addToCart').querySelector('.product-addToCart__info-price') != null){
            var popupPrice = doc.querySelector('.product-addToCart').querySelector('.product-addToCart__info-price').innerHTML
        }
        if( doc.querySelector('.product-addToCart').querySelector('.product-addToCart__status-wrapper') != null){
            var popupStatusinfo = doc.querySelector('.product-addToCart').querySelector('.product-addToCart__status-wrapper').outerHTML
        }
        if( doc.querySelector('.product-addToCart').querySelector('.js-addToCart__characteristics') != null){
            var popupSelectedOptions = doc.querySelector('.product-addToCart').querySelector('.js-addToCart__characteristics').innerHTML
        }
        if( doc.querySelector('.js-product-fixed').querySelector('.product-fixed__price') != null){
            var barPrice = doc.querySelector('.js-product-fixed').querySelector('.product-fixed__price').innerHTML
        }
        if( doc.querySelector('.js-product-addToCart__btn') != null){
            var button = doc.querySelector('.js-product-addToCart__btn').innerHTML
        }
        if( doc.querySelector('.js-counter-wrapper') != null){
            var counter = doc.querySelector('.js-counter-wrapper').innerHTML
        }
        if( doc.querySelector('.main-product__info-sku') != null){
            var info_sku = doc.querySelector('.main-product__info-sku').innerHTML
        }
        if (status_tag != null) {
            if (status_tag == 'stoke') {
                $('.main-product__buy-body .btn').addClass('js-btn-in_stock').removeAttr('data-toggle').removeAttr('data-target');
            } else if (status_tag == 'made-to-order') {
                $('.main-product__buy-body .btn').removeClass('js-btn-in_stock').attr({'data-toggle': 'modal', 'data-target': '#addToCart'});
            }
        }
        if( status != null){
            $('.js-product-info-block').find($('.main-product__info-status'))[0].outerHTML=status;
        }
        if( Status_info != null){
            $('.js-body-product').find($('.main-product__status-wrapper'))[0].outerHTML=Status_info;
            if (Status_info.includes('data-call-in="true"')) {
                $('.btn.btn-icon-left').replaceWith(`
                <div class="btn btn-icon-left disabled" data-call-in="true">
                    <i class="icon icon-i-bag"></i>
                    <span>Call to order</span>
                </div>`);
                if ($('.main-product__price').length > 0) {
                    $('.main-product__price').html(`
                        <h2 style="font-size: 1.5rem;">Call for Pricing</h2>
                    `);
                    console.log($('.main-product__price').length);
                }
            }
        }
        if( price != null){
            $('.js-body-product').find($('.js-proudct-price'))[0].innerHTML=price;
        }
        if( product_overview != null){
            $('.js-body-product').find($('.main-product__overview'))[0].innerHTML=product_overview;
        }
        if( popupPrice != null){
            $('.product-addToCart').find($('.product-addToCart__info-price'))[0].innerHTML=popupPrice;
        }
         if( popupStatusinfo != null){
             $('.product-addToCart').find($('.product-addToCart__status-wrapper'))[0].outerHTML=popupStatusinfo;
        }
         if( popupSelectedOptions != null){
             $('.product-addToCart').find($('.js-addToCart__characteristics'))[0].innerHTML=popupSelectedOptions;
        }
        if( barPrice != null){
            $('.js-product-fixed').find($('.product-fixed__price'))[0].innerHTML=barPrice;
        }
        if( button != null){
            $('.js-product-addToCart__btn')[0].innerHTML=button;
        }
        if( counter != null){
            $('.js-counter-wrapper')[0].innerHTML = counter;
        }
        if( info_sku != null){
            $('.main-product__info-sku')[0].innerHTML = info_sku;
        }
        if( variant != null){
             $('.js-body-product').find($('.main-product__characteristics'))[0].innerHTML=variant;
        }
        if( variant != null){
        $('.js-body-product').find($('.main-product__characteristics')).find($('.js-product-characteristics-select')).each(function (){
            let _this=$(this);
            var $parent = _this.closest(".sort");
            var $sortModalBody = $parent.find(".sort-modal__body");
            var $sortBtn = $parent.find(".sort-btn");
            _this.select2({width:"100%",minimumResultsForSearch:-1,templateResult: selectTemplateResult,templateSelection: selectTemplateSelection,dropdownParent: $sortModalBody});
            function selectTemplateSelection(opt) {
                var result = "\n\t\t\t<div class=\"sort-product__characteristics__result\">\n\t\t\t\t<span class=\"sort-product__characteristics__result-placeholder\">\n\t\t\t\t\t" + _this.attr("data-placeholder") + "\n\t\t\t\t</span>\t\n\t\t\t\t<span class=\"sort-product__characteristics__result-value\">\n\t\t\t\t\t" + opt.text + "\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t";
                $sortBtn.html(result);
                return $(result)
            }
            $(document).on("select2:close",_this, function (e) {
                $parent.removeClass("active")
            });
            $(document).on("click",'.sort-btn', function (e) {
                e.preventDefault();
                $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("open");
                $(this).closest(".sort").addClass("active")
            })
            $(document).on("click",'.sort-modal__close', function (e) {
                e.preventDefault();
                $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("close");
            })
        })
        }
        $(document).find($('.main-product__characteristics')).removeClass('loading');
        console.log("Success")
    }).catch(function (err) {

        console.error('Something went wrong.', err);
    });
}
function selectTemplateResult(opt) {
    if (!opt.id) {
        return opt.text
    }
    var optImage = $(opt.element).data("img");
    if (!optImage) {
        var $opt = $("<div class=\"select2-results__option-custom \">\n\t\t\t\t\t\t<span>" + opt.text + "</span>\n\t\t\t\t\t</div>");
        return $opt
    } else {
        var _$opt = $("<div class=\"select2-results__option-custom select2-results__option__multi-img\">\n\t\t\t\t\t<img src=\"" + optImage + "\" />\n\t\t\t\t\t<span>" + $(opt.element).text() + "</span>\n\t\t\t\t</div>");
        return _$opt
    }
}

